import React, { useEffect, useState } from "react";
import {
  fetchLeadData,
  Leads,
  GetLeadLog,
  LeadLgoList,
  GetUserTasks,
  UserTaskList,
} from "../Services/APIService";
import { useNavigate } from "react-router-dom";

const DashboardCards: React.FC = () => {
  const [logs, setLogs] = useState<LeadLgoList[]>([]);
  const [totalLeads, setTotalLeads] = useState<Leads[]>([]);
  const [tasks, setTasks] = useState<UserTaskList[]>([]);
  const [nextActionLeadIds, setNextActionLeadIds] = useState<number[]>([]);
  const [nextActionrequiredLeadIds, setNextActionInquiryLeadIds] = useState<number[]>([]);
  const [reconnectLeads, setreconnectLeadsLeadIds] = useState<number[]>([]);

  //nextActionrequiredLeadIds
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch lead logs
    GetLeadLog()
      .then((res) => setLogs(res))
      .catch((err) => console.error("Failed to fetch logs:", err));

    // Fetch lead data
    fetchLeadData()
      .then((res) => setTotalLeads(res))
      .catch((err) => console.error("Failed to fetch leads:", err));

    // Fetch user tasks
    GetUserTasks()
      .then((res) => setTasks(res))
      .catch((err) => console.error("Failed to fetch tasks:", err));
  }, []);

  // Count active tasks (isCompleted=false, isPostponed=false, isCanceled=false)
  const activeTasks = tasks.filter(
    (task) =>
      !task.isCompleted &&
      !task.isPostponed &&
      !task.isCanceled &&
      task.followupTypeId != 1
  ).length;

  // Handle card click navigation
  const handleCardClick = (filter: "all" | "next" | "activeTasks" | "actionRequired" | "reconnect") => {
    if (filter === "all") {
      navigate("/Leadview");
    }
    else if (filter === "next") {
      navigate("/ShowCardLeadList", {
        state: { filterType: filter, isShowFollowupIcon: true },
      });
    }
    else if (filter === "activeTasks") {
      // Navigate to a page showing active tasks (modify as needed)
      navigate("/UserActiveTask", {
        state: { filterType: filter },
      });
    }
    else if (filter === "actionRequired") {
      navigate("/ActionRequiredLead", {
        state: { filterType: filter },
      });
    }
    else if(filter === "reconnect"){
      navigate("/ReconnectLeads", {
        state: { filterType: filter },
      });
    }
  };

  useEffect(() => {
    const fetchLogs = async () => {
      const logs: LeadLgoList[] = await GetLeadLog();

      // Step 1: Filter valid logs
      const filteredLeadIds = logs
        .filter(
          (log) =>
            log.isNextActionRequired === true &&
            log.taskId === null &&
            log.statusId === 1
        )
        .map((log) => log.leadId);

      // Step 2: Remove duplicates without using Set
      const uniqueLeadIds = filteredLeadIds.filter(
        (value, index, self) => self.indexOf(value) === index
      );

      // Step 3: Remove leadIds where ANY record has isNextActionRequired = false
      const nextActionLeadIds = uniqueLeadIds.filter(
        (leadId) =>
          !logs.some(
            (log) =>
              log.leadId === leadId &&
              log.isNextActionRequired === false
          )
      );

      console.log("nextActionLeadIds", nextActionLeadIds);
      setNextActionLeadIds(nextActionLeadIds);
    };

    fetchLogs();
  }, []);

  useEffect(() => {
    const fetchLogs = async () => {
      const logs: LeadLgoList[] = await GetLeadLog();

      const nextActionrequiredLeadIds = logs
        .filter((log) => log.statusId > 1 || log.followupConducted > 0)
        .map((log) => log.leadId)
        .filter((value, index, self) => self.indexOf(value) === index);
      console.log("nextActionrequiredLeadIds", nextActionrequiredLeadIds);

      setNextActionInquiryLeadIds(nextActionrequiredLeadIds);
    };

    fetchLogs();
  }, []);

  useEffect(() => {
    const fetchLogs = async () => {
      const logs: LeadLgoList[] = await GetLeadLog();

      const reconnectLeads = logs
        .filter(
          (log) =>
            log.eventTypeId === 6
        )
        .map((log) => log.leadId)
        .filter((value, index, self) => self.indexOf(value) === index);

      console.log("reconnectLeads", reconnectLeads);

      setreconnectLeadsLeadIds(reconnectLeads);
    };

    fetchLogs();
  }, []);
  // const nextActionRequired = logs.filter(
  //   (log) => log.isNextActionRequired && log.taskId === null
  // ).length;

  return (
    <div className="row pt-4">

      <div className="col mb-3">

        <div
          className="dashboardCountCard gradient-orange text-white text-center p-3 rounded-3 shadow-sm"
          onClick={() => handleCardClick("next")}
          style={{ cursor: "pointer" }}
        >
          <h6 className="mb-1">New Inquiry</h6>
          <h3 className="fw-bold">{nextActionLeadIds.length}</h3>
        </div>
      </div>

      <div className="col mb-3">
        <div
          className="dashboardCountCard gradient-purple text-white text-center p-3 rounded-3 shadow-sm"
          onClick={() => handleCardClick("reconnect")}
          style={{ cursor: "pointer" }}
        >
          <h6 className="mb-1">Reconnect</h6>
          <h3 className="fw-bold">{reconnectLeads.length}</h3>
        </div>
      </div>

      <div className="col mb-3">
        <div
          className="dashboardCountCard gradient-orange text-white text-center p-3 rounded-3 shadow-sm"
          onClick={() => handleCardClick("actionRequired")}
          style={{ cursor: "pointer" }}
        >
          <h6 className="mb-1">Action Required</h6>
          <h3 className="fw-bold">{nextActionrequiredLeadIds.length}</h3>
        </div>
      </div>

      <div className="col mb-3">
        <div
          className="dashboardCountCard gradient-blue text-white text-center p-3 rounded-3 shadow-sm"
          onClick={() => handleCardClick("activeTasks")}
          style={{ cursor: "pointer" }}
        >
          <h6 className="mb-1">Active Tasks</h6>
          <h3 className="fw-bold">{activeTasks}</h3>
        </div>
      </div>

      <div className="col mb-3">
        <div
          className="dashboardCountCard gradient-purple text-white text-center p-3 rounded-3 shadow-sm"
          onClick={() => handleCardClick("all")}
          style={{ cursor: "pointer" }}
        >
          <h6 className="mb-1">Total Leads</h6>
          <h3 className="fw-bold">{totalLeads.length}</h3>
        </div>
      </div>

    </div>

  );
};

export default DashboardCards;
